const FAV_KEY = "favorites";

// Guarda solo lo necesario para pintar la tarjeta y enlazar al producto.
const normalizeFav = (item) => ({
  producto_id: item.producto_id,
  nombre: item.nombre ?? item.nombre_producto ?? "",
  no_parte: item.no_parte ?? null,
  precio_unitario: Number(item.precio_unitario || 0),
  precio_efectivo: Number(item.precio_efectivo ?? item.precio_unitario ?? 0),
  en_oferta: Boolean(item.en_oferta),
  descuento_porcentaje: Number(item.descuento_porcentaje || 0),
  cantidad_disponible: Number(item.cantidad_disponible ?? 0),
  url_image: item.url_image ?? item.imagen ?? null,
});

export const getFavorites = () => {
  const data = localStorage.getItem(FAV_KEY);
  if (!data) return [];
  try {
    const list = JSON.parse(data);
    if (!Array.isArray(list)) return [];
    return list.map(normalizeFav);
  } catch {
    return [];
  }
};

// Notifica a otros componentes (ej. el header) que los favoritos cambiaron en esta pestaña.
const notifyFavoritesUpdated = () => {
  try {
    window.dispatchEvent(new Event("favorites:updated"));
  } catch {
    /* noop (SSR / sin window) */
  }
};

export const saveFavorites = (list) => {
  localStorage.setItem(FAV_KEY, JSON.stringify(list));
  notifyFavoritesUpdated();
};

export const getFavoritesCount = () => getFavorites().length;

export const isFavorite = (productoId) =>
  getFavorites().some((f) => f.producto_id === productoId);

export const addFavorite = (product) => {
  const list = getFavorites();
  if (list.some((f) => f.producto_id === product.producto_id)) return list;
  const next = [normalizeFav(product), ...list];
  saveFavorites(next);
  return next;
};

export const removeFavorite = (productoId) => {
  const next = getFavorites().filter((f) => f.producto_id !== productoId);
  saveFavorites(next);
  return next;
};

// Alterna un producto: lo agrega si no está, lo quita si ya está.
export const toggleFavorite = (product) => {
  if (isFavorite(product.producto_id)) {
    removeFavorite(product.producto_id);
    return false;
  }
  addFavorite(product);
  return true;
};

export const clearFavorites = () => {
  saveFavorites([]);
};
